module.exports = __webpack_public_path__ + "static/media/cy-base-show.758dcc13.png";